// Responsive WebP image with srcset/sizes, fixed dimensions (no CLS), lazy by default.
export const SmartImage = ({
  base,
  alt,
  widths = [200, 400, 800, 1200],
  sizes = "(max-width: 1023px) 30vw, 220px",
  width = 1200,
  height = 1600,
  className = "",
  eager = false,
  ...rest
}) => {
  const srcSet = widths.map((w) => `/images/${base}-${w}.webp ${w}w`).join(", ");
  const fallback = `/images/${base}-${widths[Math.min(1, widths.length - 1)]}.webp`;
  return (
    <img
      src={fallback}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      width={width}
      height={height}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={eager ? "high" : "auto"}
      className={className}
      {...rest}
    />
  );
};
